<template>
<v-dialog v-model="dialog" scrollable max-width="1180px" transition="dialog-transition" persistent :fullscreen="$vuetify.breakpoint.smAndDown" @keydown.esc="emitExit()">
    <v-card flat class="hotel-modal" id="hotel-policy">
        <v-card-title primary-title>
            <div class="pl-2 hotel-modal-header">
                {{ $t('hotel.modal.policy.title') }}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text :class="{'scroll-card':true, 'px-3':$vuetify.breakpoint.smAndDown}">
            <v-form v-model="valid" ref="hotel_policy">
                <v-row>
                    <!-- hours for Check-in & Check-out -->
                    <v-col md="6" cols="12" class="py-0">
                        <v-row align="end" no-gutters>
                            <v-col md="4" cols="4" class="hotel-modal-title">
                                <div>Check-in</div>
                            </v-col>
                            <v-col md="4" cols="4" class="px-2">
                                <v-menu v-model="menu2" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px" :close-on-content-click="false">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="item.static.policy.checkin.from" :label="$t('hotel.policy.from')" required :rules="rules.time" ref="time_picker" readonly hide-details />
                                    </template>
                                    <im-time-picker :value="item.static.policy.checkin.from" @update="updateCIFrom($event)"></im-time-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="4" cols="4" class="px-2">
                                <v-menu v-model="menu3" :return-value.sync="time" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px" :close-on-content-click="false">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="item.static.policy.checkin.to" :label="$t('hotel.policy.until')" readonly hide-details />
                                    </template>
                                    <im-time-picker :value="item.static.policy.checkin.to" @update="updateCITo($event)"></im-time-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <div class="faded">
                            {{ $t('hotel.modal.policy.info_text.checkin') }}
                        </div>
                    </v-col>
                    <v-col md="6" cols="12" class="py-0">
                        <v-row align="end" no-gutters>
                            <v-col md="4" cols="4" class="hotel-modal-title">
                                <div>Check-out</div>
                            </v-col>
                            <v-col md="4" cols="4" class="px-2">
                                <v-menu v-model="menu4" :close-on-content-click="false" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="item.static.policy.checkout.from" :label="$t('hotel.policy.from')" readonly hide-details />
                                    </template>
                                    <im-time-picker :value="item.static.policy.checkout.from" @update="updateCOFrom($event)"></im-time-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="4" cols="4" class="px-2">
                                <v-menu v-model="menu5" :close-on-content-click="false" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-on="on" v-model="item.static.policy.checkout.to" :label="$t('hotel.policy.until')" required :rules="rules.time" readonly hide-details />
                                    </template>
                                    <im-time-picker :value="item.static.policy.checkout.to" @update="updateCOTo($event)"></im-time-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <div class="faded">
                            {{ $t('hotel.modal.policy.info_text.checkout') }}
                        </div>
                    </v-col>
                </v-row>
                <!-- ./ hours for Check-in & Check-out -->
                <!-- weekend-days selection -->
                <div class="py-2">
                    <div class="weekend-days  d-flex align-center">
                        <div class="hotel-modal-title text-xs-center pr-2">{{ $t('hotel.policy.title_weekend_days') }}</div>
                        <div class="d-flex" style="overflow: auto">
                            <v-btn class="mx-1 regular" v-for="(day,index) in days" :key="index" small rounded depressed :color="day.selected ? 'primary' : 'grey lighten-2'" :text-color="day.selected ? 'white' : 'grey'" @click="selectDays(day)">
                                <span class="text-capitalize">{{ $t('week_days_short.' + day.text) }}</span>
                            </v-btn>
                        </div>
                    </div>
                    <div class="faded">
                        {{ $t('hotel.modal.policy.info_text.weekend') }}
                    </div>
                </div>
                <!-- ./ weekend-days selection -->

                <!-- languages -->
                <v-row>
                    <v-col md="4" cols="12">
                        <v-autocomplete :class="{'ma-0 pa-0':$vuetify.breakpoint.mdAndUp}" :label="$t('hotel.policy.language')" v-model="item.language" :items="config.languages" item-text="name" item-value="code" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                            :rules="rules.language" :hint="$t('hotel.modal.policy.info_text.language')" persistent-hint required />
                    </v-col>
                    <v-col md="8" cols="12">
                        <v-autocomplete :class="{'ma-0 pa-0':$vuetify.breakpoint.mdAndUp}" :label="$t('hotel.policy.spoken_languages')" v-model="item.static.policy.spoken_languages" :items="config.languages" item-text="name" item-value="code"
                            multiple chips deletable-chips small-chips :rules="rules.languages" :hint="$t('hotel.modal.policy.info_text.spoken_languages')" persistent-hint required :menu-props="{transition:'scale-transition', 'offset-y': ''}" />
                    </v-col>
                </v-row>
                <!-- ./ languages -->

                <v-divider class="my-2" />

                <!-- currencies -->
                <div class="py-1">
                    <div class="hotel-modal-title ">{{ $t('hotel.policy.title_payment') }}</div>
                    <v-row>
                        <v-col md="4" cols="12">
                            <v-select :items="config.currencies_slug" v-model="item.static.defaults.currency" :label="$t('hotel.policy.currency')" :menu-props="{transition:'scale-transition', 'offset-y': ''}" :rules="rules.money" :hint="$t('hotel.modal.policy.info_text.currency')"
                                persistent-hint required />
                        </v-col>
                        <v-col md="4" cols="12">
                            <v-select :items="config.currencies_slug" v-model="item.static.financial.currencies" :label="$t('hotel.policy.accepted_currencies')" multiple chips small-chips deletable-chips :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                :rules="rules.currencies" :hint="$t('hotel.modal.policy.info_text.currencies')" persistent-hint required />
                        </v-col>
                        <v-col md="4" cols="12">
                            <v-select class="text-capitalize" :items="config.accepted_cards_slug" v-model="item.static.financial.accepted_cards" item-text="text" item-value="slug" :label="$t('hotel.policy.allowed_cards')" multiple chips
                                deletable-chips small-chips :hint="$t('hotel.modal.policy.info_text.accepted_cards')" persistent-hint :menu-props="{transition:'scale-transition', 'offset-y': ''}">
                            </v-select>
                        </v-col>
                    </v-row>
                </div>
                <!-- ./ currencies -->

                <v-divider class="my-1" />

                <!-- policy children -->
                <div>
                    <div class="hotel-modal-title pl-2 pt-2">
                        {{ $t('hotel.policy.title_children') }}
                    </div>
                    <div class="pl-2">
                        <div class="detail orange--text">
                            *tarifele pentru copii se vor aplica doar pentru paturi suplimentare
                        </div>
                    </div>
                    <v-row align="center">
                        <v-col md="5" cols="12" class="py-0">
                            <v-checkbox :label="$t('hotel.policy.children.allowed')" color="primary" v-model="policy_children.allowed" />
                        </v-col>
                        <v-col md="7" cols="12" class="py-0" v-if="(policy_children.infants.allowed || policy_children.small_children.allowed || policy_children.big_children.allowed)&&($vuetify.breakpoint.mdAndUp)">
                            <v-row align="center">
                                <v-col cols="6" class="py-0" style="font-weight: 500">
                                    {{ $t('hotel.policy.children.age_groups') }}
                                    <span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="grey darken-2 pb-2" size="16" v-on="on" style="vertical-align: middle">info_outline</v-icon>
                                            </template>
                                            <span>{{ $t('hotel.policy.tooltip.children') }}</span>
                                        </v-tooltip>
                                    </span>
                                </v-col>
                                <v-col cols="6" class="py-0" style="font-weight: 500">
                                    {{ $t('hotel.policy.children.extra_beds_rates') }}
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>
                    <div :class="{'drop-down': true, 'open': policy_children.allowed}">
                        <v-row>
                            <v-col md="5" cols="12" class="py-0">
                                <v-checkbox :label="$t('hotel.policy.children.infants')" color="primary" v-model="policy_children.infants.allowed" @change="infantsPolicy()" :hint="$t('hotel.modal.policy.info_text.infants')" persistent-hint />
                            </v-col>
                            <v-col md="7" cols="12" class="py-0" v-if="policy_children.infants.allowed">
                                <v-row>
                                    <v-col md="6" cols="12" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.infants.age.from" :label="$t('hotel.policy.children.from')" disabled />
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field class="" v-model="policy_children.infants.age.to" :label="$t('hotel.policy.children.until')" @input="changeInfantsAgeTo()" :rules="rules.infant_age" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col md="6" cols="12" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field class="" v-model="policy_children.infants.price.value" :label="$t('hotel.policy.children.value')" />
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-select class="text-truncate" :items="price_value_children" v-model="policy_children.infants.price.type" item-text="text" item-value="value" :label="$t('hotel.policy.children.payment')" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="5" cols="12" class="py-0">
                                <v-checkbox :label="$t('hotel.policy.children.small_children')" color="primary" v-model="policy_children.small_children.allowed" :hint="$t('hotel.modal.policy.info_text.small_children')" persistent-hint @change="smallChildPolicy()" />
                            </v-col>
                            <v-col md="7" cols="12" class="py-0" v-if="policy_children.small_children.allowed">
                                <v-row>
                                    <v-col md="6" cols="12" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.small_children.age.from" :label="$t('hotel.policy.children.from')" :disabled="!!(policy_children.infants.allowed)" :rules="rules.small_age_from" @input="changeSmallAgeFrom()" />
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.small_children.age.to" :label="$t('hotel.policy.children.until')" @input="changeSmallAgeTo()" :rules="rules.small_age_to" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col md="6" cols="12" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.small_children.price.value" :label="$t('hotel.policy.children.value')" />
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-select class="text-truncate" :items="price_value_children" v-model="policy_children.small_children.price.type" item-text="text" item-value="value" :label="$t('hotel.policy.children.payment')" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="5" cols="12" class="py-0">
                                <v-checkbox :label="$t('hotel.policy.children.big_children')" color="primary" v-model="policy_children.big_children.allowed" :hint="$t('hotel.modal.policy.info_text.big_children')" persistent-hint @change="bigChildPolicy()" />
                            </v-col>
                            <v-col md="7" cols="12" class="py-0" v-if="policy_children.big_children.allowed">
                                <v-row>
                                    <v-col md="6" cols="12" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.big_children.age.from" :label="$t('hotel.policy.children.from')" @input="changeBigAgeFrom()" :rules="rules.big_age_from" :disabled="!(!policy_children.infants.allowed&&!policy_children.small_children.allowed)" />
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.big_children.age.to" :label="$t('hotel.policy.children.until')" :rules="rules.big_age_to" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col md="6" cols="12" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="py-0">
                                                <v-text-field v-model="policy_children.big_children.price.value" :label="$t('hotel.policy.children.value')" />
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-select class="text-truncate" :items="price_value_children" v-model="policy_children.big_children.price.type" item-text="text" item-value="value" :label="$t('hotel.policy.children.payment')" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <!-- ./ policy children -->
                <v-divider class="my-3" />
                <div class="hotel-modal-title pl-2 pt-2">
                    {{ $t('hotel.policy.title_extra_beds_single_stay') }}
                </div>
                <v-row>
                    <v-col md="6" cols="12" class="py-0">
                        <div class="">
                            <v-checkbox :label="$t('hotel.policy.extra_beds.title')" color="primary" v-model="extra_bed" :hint="$t('hotel.modal.policy.info_text.extra_beds')" persistent-hint />
                        </div>
                        <div :class="{'drop-down': true, 'open': extra_bed}">
                            <v-row v-if="extra_bed">
                                <v-col cols="6">
                                    <v-text-field v-model="policy_extra_beds.value" :label="$t('hotel.policy.extra_beds.value')" />
                                </v-col>
                                <v-col cols="6">
                                    <v-select class="text-truncate" :items="price_value_extra_beds" v-model="policy_extra_beds.type" item-text="text" item-value="value" :label="$t('hotel.policy.extra_beds.payment')" />
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-col md="6" cols="12" class="py-0">
                        <div>
                            <v-checkbox :label="$t('hotel.policy.single_stay.title')" color="primary" v-model="single_stay" :hint="$t('hotel.modal.policy.info_text.single_stay')" persistent-hint />
                        </div>
                        <div :class="{'drop-down': true, 'open': single_stay}">
                            <v-row v-if="single_stay">
                                <v-col cols="6">
                                    <v-text-field v-model="policy_single_stay.value" :label="$t('hotel.policy.single_stay.value')" required :rules="rules.value" />
                                </v-col>
                                <v-col cols="6">
                                    <v-select class="text-truncate" :items="price_value_single_stay" v-model="policy_single_stay.type" item-text="text" item-value="value" :label="$t('hotel.policy.single_stay.payment')" />
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>

                <div>
                    <div class="hotel-modal-title pl-2 pt-2">{{ $t('hotel.policy.title_terms') }}</div>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-tabs v-model="terms" slider-color="orange" right :class="{'px-2':$vuetify.breakpoint.smAndUp}">
                                <!-- hotel terms and conditions -->
                                <v-tab ripple>
                                    <v-avatar size="24" class="mr-2" tile>
                                        <img :src="ro" alt="alt">
                                    </v-avatar>
                                    <span v-if="$vuetify.breakpoint.smAndUp">Romana</span>
                                    <span v-else>RO</span>
                                </v-tab>
                                <v-tab-item>
                                    <v-textarea filled label="Termeni si conditii" v-model="item.terms.ro" />
                                </v-tab-item>
                                <v-tab ripple>
                                    <v-avatar size="24" class="mr-2" tile>
                                        <img :src="gb" alt="alt">
                                    </v-avatar>
                                    <span v-if="$vuetify.breakpoint.smAndUp">English</span>
                                    <span v-else>EN</span>
                                </v-tab>
                                <v-tab-item>
                                    <v-textarea filled label="Terms and conditions" v-model="item.terms.en" />
                                </v-tab-item>
                            </v-tabs>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import ro_flag from '../../../../assets/ro.svg';
import gb_flag from '../../../../assets/gb.svg';
import IMTimePicker from '../../../small-components/IMTimePicker.vue';

export default {
    props: {
        dialog: Boolean,
        item: Object,
        config: Object,
        active: Object
    },
    name: `hotel-policy`,
    components: {
        "im-time-picker": IMTimePicker
    },

    data() {
        return {
            valid: false,
            ro: ro_flag,
            gb: gb_flag,
            loading_save: false,
            days: [
                {
                    text: "monday",
                    value: "1",
                    selected: false
                }, {
                    text: "tuesday",
                    value: "2",
                    selected: false
                }, {
                    text: "wednesday",
                    value: "3",
                    selected: false
                }, {
                    text: "thursday",
                    value: '4',
                    selected: false
                }, {
                    text: "friday",
                    value: "5",
                    selected: true
                }, {
                    text: "saturday",
                    value: "6",
                    selected: true
                }, {
                    text: "sunday",
                    value: "0",
                    selected: true
                }
            ],

            // time picker
            time: null,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,

            terms: null,

            // input input items
            allowed_cards: [],
            languages: [],

            infants: true,

            policy_single_stay: {
                value: null,
                type: null
            },
            policy_extra_beds: {
                value: null,
                type: null
            },

            policy_children: {
                allowed: false,
                infants: {
                    allowed: false,
                    age: {
                        from: 0,
                        to: 2
                    },
                    price: {
                        type: "percent",
                        value: "25"
                    }
                },
                small_children: {
                    allowed: false,
                    age: {
                        from: 2,
                        to: 6
                    },
                    price: {
                        type: "percent",
                        value: "50"
                    }
                },
                big_children: {
                    allowed: false,
                    age: {
                        from: 6,
                        to: 12
                    },
                    price: {
                        type: "percent",
                        value: "75"
                    }
                },
            }
        };
    },

    created() {
        this.days.forEach(function (day, index) {
            if(this.item.static.defaults.weekend.includes(day.value)) {
                day.selected = true;
            } else {
                day.selected = false;
            }
        }.bind(this));
        this.writePolicyChildren();
        this.writePolicyExtra();
    },

    watch: {
        'item.static.defaults.weekend': function (old_hotel, new_hotel) {
            this.days.forEach(function (day, index) {
                if(this.item.static.defaults.weekend.includes(day.value)) {
                    day.selected = true;
                } else {
                    day.selected = false;
                }
            }.bind(this))
        },
        'item.static.policy.children': function (old_hotel, new_hotel) {
            this.writePolicyChildren();
        },
        'item.static.policy': function (old_hotel, new_hotel) {
            this.writePolicyExtra();
        },

        policy_children: {
            handler() {
                if(this.policy_children.allowed == false) {
                    this.policy_children.infants.allowed = false;
                    this.policy_children.small_children.allowed = false;
                    this.policy_children.big_children.allowed = false;
                }

            },
            deep: true
        },

    },

    computed: {
        single_stay: {
            get: function () {
                return !!this.policy_single_stay.value || !!this.policy_single_stay.type
            },
            set: function (val) {
                if(val) {
                    this.policy_single_stay.value = "70";
                    this.policy_single_stay.type = "percent";
                } else {
                    this.policy_single_stay.value = null;
                    this.policy_single_stay.type = null;
                }
            }
        },
        extra_bed: {
            get: function () {
                return !!this.policy_extra_beds.value || !!this.policy_extra_beds.type
            },
            set: function (val) {
                if(val) {
                    this.policy_extra_beds.value = "70";
                    this.policy_extra_beds.type = "percent";
                } else {
                    this.policy_extra_beds.value = null;
                    this.policy_extra_beds.type = null;
                }
            }
        },
        price_value_children() {
            return [
                {
                    text: this.$t('hotel.policy.children.percent_text'),
                    value: 'percent'
                }, {
                    text: this.checkCurrency(),
                    value: "flat"
                },
            ]
        },
        price_value_single_stay() {
            return [
                {
                    text: this.$t('hotel.policy.single_stay.percent_text'),
                    value: 'percent'
                }, {
                    text: this.checkCurrency(),
                    value: "flat"
                },
            ]
        },
        price_value_extra_beds() {
            return [
                {
                    text: this.$t('hotel.policy.extra_beds.percent_text'),
                    value: 'percent'
                }, {
                    text: this.checkCurrency(),
                    value: "flat"
                },
            ]
        },
        rules() {
            return {
                time: [
                    v => !!v || this.$t('hotel.policy.form_rules.time_required'),
                    v => /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || this.$t('hotel.policy.form_rules.time_format')
                ],
                checkin_from: [
                    v => !!v || this.$t('hotel.policy.form_rules.time_required'),
                    v => /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || this.$t('hotel.policy.form_rules.time_format'),
                    // v => this.$moment(this.item.static.policy.checkin.from, 'HH:mm')
                    // .isBefore(v, 'HH:mm') || "time bigger",
                ],
                language: [v => !!v || this.$t('hotel.policy.form_rules.language')],
                languages: [v => v.length > 0 || this.$t('hotel.policy.form_rules.spoken_languages')],
                money: [v => !!v || this.$t('hotel.policy.form_rules.currency')],
                currencies: [v => v.length > 0 || this.$t('hotel.policy.form_rules.currencies')],
                value: [v => !!v || "valoare necesara"],
                infant_age: [
                    v => /^[0-9]{1,2}$/.test(v) || this.$t('hotel.policy.form_rules.age_number'),
                    v => v > 0 || this.$t('hotel.policy.form_rules.age_bigger')
                ],
                small_age_from: [
                    v => /^[0-9]{1,2}$/.test(v) || this.$t('hotel.policy.form_rules.age_number'),
                    v => Number(v) >= 0 || this.$t('hotel.policy.form_rules.age_bigger')
                ],
                small_age_to: [
                    v => /^[0-9]{1,2}$/.test(v) || this.$t('hotel.policy.form_rules.age_number'),
                    v => Number(v) > this.policy_children.small_children.age.from || this.$t('hotel.policy.form_rules.age_bigger')
                ],
                big_age_from: [
                    v => /^[0-9]{1,2}$/.test(v) || this.$t('hotel.policy.form_rules.age_number'),
                    v => Number(v) >= 0 || this.$t('hotel.policy.form_rules.age_bigger')
                ],
                big_age_to: [
                    v => /^[0-9]{1,2}$/.test(v) || this.$t('hotel.policy.form_rules.age_number'),
                    v => Number(v) > this.policy_children.big_children.age.from || this.$t('hotel.policy.form_rules.age_bigger')
                ]
            }
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        checkCurrency() {
            if(this.item.static.defaults.currency) {
                return this.item.static.defaults.currency
            } else {
                return "fix"
            }
        },

        selectDays(day) {
            day.selected = !day.selected;
            if(day.selected) {
                this.item.static.defaults.weekend.push(day.value)
            } else {
                let index = this.item.static.defaults.weekend.indexOf(day.value);
                this.item.static.defaults.weekend.splice(index, 1);
            }
        },

        // policy children
        infantsPolicy() {
            if(this.policy_children.infants.allowed == 1) {
                this.policy_children.infants.age.from = 0;
                this.policy_children.infants.age.to = 2;
                if(this.policy_children.small_children.allowed == 1) {
                    this.policy_children.small_children.age.from = this.policy_children.infants.age.to;
                }
                if(this.policy_children.big_children.allowed == 1 && this.policy_children.small_children.allowed == 0) {
                    this.policy_children.big_children.age.from = this.policy_children.infants.age.to;
                }
            }
            if(this.policy_children.infants.allowed == 0) {
                if(this.policy_children.small_children.allowed == 1) {
                    this.policy_children.small_children.age.from = 2;
                }
                if(this.policy_children.big_children.allowed == 1 && this.policy_children.small_children.allowed == 0) {
                    this.policy_children.big_children.age.from = 2;
                }
            }
        },

        smallChildPolicy() {
            if(this.policy_children.small_children.allowed == 1) {
                if(this.policy_children.infants.allowed == 0) {
                    this.policy_children.small_children.age.from = 0;
                }
                if(this.policy_children.infants.allowed == 1) {
                    this.policy_children.small_children.age.from = this.policy_children.infants.age.to;
                }
                if(this.policy_children.infants.allowed == 1 && this.policy_children.big_children.allowed == 1) {
                    this.policy_children.small_children.age.from = this.policy_children.infants.age.to;
                }
                if(this.policy_children.big_children.allowed == 1) {
                    this.policy_children.big_children.age.from = this.policy_children.small_children.age.to;
                }
            }
            if(this.policy_children.small_children.allowed == 0) {
                if(this.policy_children.infants.allowed == 0 && this.policy_children.big_children.allowed == 1) {
                    this.policy_children.big_children.age.from = 2;
                }
                if(this.policy_children.infants.allowed == 1 && this.policy_children.big_children.allowed == 1) {
                    this.policy_children.big_children.age.from = this.policy_children.infants.age.to;
                }
            }
        },

        bigChildPolicy() {
            if(this.policy_children.big_children.allowed == 1) {
                if(this.policy_children.infants.allowed == 0 && this.policy_children.small_children.allowed == 0) {
                    this.policy_children.big_children.age.from = 2;
                }
                if(this.policy_children.small_children.allowed == 1) {
                    this.policy_children.big_children.age.from = this.policy_children.small_children.age.to;
                }
                if(this.policy_children.infants.allowed == 1 && this.policy_children.small_children.allowed == 0) {
                    this.policy_children.big_children.age.from = this.policy_children.infants.age.to;
                }
            }
        },

        changeInfantsAgeTo() {
            if(this.policy_children.small_children.allowed == 1) {
                this.policy_children.small_children.age.from = this.policy_children.infants.age.to;
                if(Number(this.policy_children.small_children.age.to) <= Number(this.policy_children.small_children.age.from)) {
                    this.policy_children.small_children.age.to = parseInt(this.policy_children.small_children.age.from) + 1;
                    this.policy_children.big_children.age.from = this.policy_children.small_children.age.to;
                    if(Number(this.policy_children.big_children.age.to) <= Number(this.policy_children.big_children.age.from)) {
                        this.policy_children.big_children.age.to = parseInt(this.policy_children.big_children.age.from) + 1;
                    }
                }
            }
            if(this.policy_children.big_children.allowed == 1 && this.policy_children.small_children.allowed == 0) {
                this.policy_children.big_children.age.from = this.policy_children.infants.age.to;
                if(Number(this.policy_children.big_children.age.to) < Number(this.policy_children.big_children.age.from)) {
                    this.policy_children.big_children.age.to = Number(this.policy_children.big_children.age.from) + 1;
                }
            }
        },

        changeSmallAgeFrom() {
            if(this.policy_children.small_children.allowed && !this.policy_children.infants.allowed) {
                if(Number(this.policy_children.small_children.age.from) >= Number(this.policy_children.small_children.age.to)) {
                    this.policy_children.small_children.age.to = Number(this.policy_children.small_children.age.from) + 1;
                    if(this.policy_children.big_children.allowed) {
                        this.policy_children.big_children.age.from = this.policy_children.small_children.age.to;
                        if(Number(this.policy_children.big_children.age.from) >= Number(this.policy_children.big_children.age.to)) {
                            this.policy_children.big_children.age.to = Number(this.policy_children.big_children.age.from) + 1;
                        }
                    }
                }
            }
        },

        changeSmallAgeTo() {
            this.policy_children.big_children.age.from = this.policy_children.small_children.age.to;

            if(this.policy_children.big_children.age.to <= this.policy_children.big_children.age.from) {
                this.policy_children.big_children.age.to = parseInt(this.policy_children.big_children.age.from) + 1;
            }
        },

        changeBigAgeFrom() {
            if(Number(this.policy_children.big_children.age.to) < Number(this.policy_children.big_children.age.from)) {
                this.policy_children.big_children.age.to = Number(this.policy_children.big_children.age.from) + 1;
            }
        },

        updateCIFrom(value) {
            this.menu2 = false;
            this.item.static.policy.checkin.from = value;
        },
        updateCITo(value) {
            this.menu3 = false;
            this.item.static.policy.checkin.to = value;
        },
        updateCOFrom(value) {
            this.menu4 = false;
            this.item.static.policy.checkout.from = value;
        },
        updateCOTo(value) {
            this.menu5 = false;
            this.item.static.policy.checkout.to = value;
        },

        writePolicyExtra() {
            this.policy_single_stay.type = this.item.static.policy.single_stay.type;
            this.policy_single_stay.value = this.item.static.policy.single_stay.value;
            this.policy_extra_beds.type = this.item.static.policy.extra_beds.type;
            this.policy_extra_beds.value = this.item.static.policy.extra_beds.value;
        },

        writePolicyChildren() {
            this.policy_children = this.$clone(this.item.static.policy.children);
            if(this.item.static.policy.children.allowed == "0") {
                this.policy_children.allowed = false;
            }
            if(this.item.static.policy.children.allowed == "1") {
                this.policy_children.allowed = true;
            }
            if(this.item.static.policy.children.infants.allowed == "0") {
                this.policy_children.infants.allowed = false;
            }
            if(this.item.static.policy.children.infants.allowed == "1") {
                this.policy_children.infants.allowed = true;
            }
            if(this.item.static.policy.children.small_children.allowed == "0") {
                this.policy_children.small_children.allowed = false;
            }
            if(this.item.static.policy.children.small_children.allowed == "1") {
                this.policy_children.small_children.allowed = true;
            }
            if(this.item.static.policy.children.big_children.allowed == "0") {
                this.policy_children.big_children.allowed = false;
            }
            if(this.item.static.policy.children.big_children.allowed == "1") {
                this.policy_children.big_children.allowed = true;
            }
        },

        save() {
            this.loading_save = true;
            // prepare some data for saving
            let model = {
                language: this.item.language,
                static: {
                    defaults: {
                        currency: this.item.static.defaults.currency,
                        weekend: this.item.static.defaults.weekend,
                    },
                    financial: {
                        currencies: this.item.static.financial.currencies,
                        accepted_cards: this.item.static.financial.accepted_cards,
                    },
                    policy: {
                        checkin: {
                            from: this.item.static.policy.checkin.from,
                            to: this.item.static.policy.checkin.to,
                        },
                        checkout: {
                            from: this.item.static.policy.checkout.from,
                            to: this.item.static.policy.checkout.to,
                        },
                        children: {
                            allowed: this.policy_children.allowed ? "1" : "0",
                            big_children: {
                                allowed: this.policy_children.big_children.allowed ? "1" : "0",
                                age: {
                                    from: this.policy_children.big_children.age.from,
                                    to: this.policy_children.big_children.age.to,
                                },
                                price: {
                                    type: this.policy_children.big_children.price.type,
                                    value: this.policy_children.big_children.price.value
                                }
                            },
                            small_children: {
                                allowed: this.policy_children.small_children.allowed ? "1" : "0",
                                age: {
                                    from: this.policy_children.small_children.age.from,
                                    to: this.policy_children.small_children.age.to,
                                },
                                price: {
                                    type: this.policy_children.small_children.price.type,
                                    value: this.policy_children.small_children.price.value
                                }
                            },
                            infants: {
                                allowed: this.policy_children.infants.allowed ? "1" : "0",
                                age: {
                                    from: this.policy_children.infants.age.from,
                                    to: this.policy_children.infants.age.to,
                                },
                                price: {
                                    type: this.policy_children.infants.price.type,
                                    value: this.policy_children.infants.price.value
                                }
                            },
                        },
                        single_stay: {
                            value: this.policy_single_stay.value,
                            type: this.policy_single_stay.type,
                        },
                        extra_beds: {
                            value: this.policy_extra_beds.value,
                            type: this.policy_extra_beds.type,
                        },
                    },
                    spoken_languages: this.item.static.policy.spoken_languages
                },
                terms: {
                    ro: this.item.terms.ro,
                    en: this.item.terms.en
                }
            };
            let hotel = this.$clone(this.item);
            delete hotel.address;
            hotel.static.images = [];
            hotel.static.policy.children = model.static.policy.children;
            hotel.static.policy.single_stay = model.static.policy.single_stay;
            hotel.static.policy.extra_beds = model.static.policy.extra_beds;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            this.$axios.put(endpoint + this.item.id, hotel)
                .then(response => {
                    this.$emit('update')
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

        emitExit() {
            this.$emit('exit')
        }
    },

};
</script>

<style lang="stylus">
.drop-down
    max-height: 0px
    transition: max-height 0.25s ease-out
    overflow: hidden
    &.open
        max-height: fit-content
        transition: max-height 0.25s ease-in
</style>
